<div class="ifra-survey-use-container indent-left-md indent-top-sm">
    <div>
        <survey-reported-use></survey-reported-use>
    </div>
</div>

